import React from "react";

const NeedHelp: React.FC = () => {

  return (
    <>
      <div className="need-help">
        <h2>Need help?</h2>
        <p>Please get in touch if you have any problems or questions.</p>
        <p className="tel"><a className="blue" href="tel:+44(0)208 332 3248">+44 (0)208 332 3248</a></p>
        <p className="email"><a className="blue" href="mailto:donate@kew.org">donate@kew.org</a></p>
      </div>
    </>
  );
};

export default NeedHelp;